<template>
  <div :key="$store.getters['resource/currentResource'].key">
    <help :text="$t('help.tievent')" :title="$t('help.tievent_title')" />

    <v-server-table
      ref="appTable"
      name="tiEventsTable"
      url="/admin/ti-events"
      :columns="columns"
      :options="options"
      @loaded="loading = false"
      @loading="loading = true"
      class="white-container"
    >
      <template slot="beforeFilter">
        <b-row>
          <b-col>
            <router-link to="tievents/create">
              <b-button class="px-4">
                {{ $t('tievent.add_event') }}
              </b-button>
            </router-link>
          </b-col>
        </b-row>
      </template>

      <template slot="id" slot-scope="props">
        <router-link
          :to="{ path: `/tievents/edit/${props.row.id}`, params: props.row }"
          target="_blank"
        >
          {{ props.row.id }}
        </router-link>
      </template>

      <template slot="beforeLimit" v-if="totalRecordsCount > 10">
        {{ $t('global.showing') }}&nbsp;
      </template>

      <template slot="afterLimit" v-if="totalRecordsCount > 10">
        &nbsp;{{ $t('global.of_records_found', { number: totalRecordsCount }) }}
      </template>

      <template slot="active" slot-scope="props">
        <column-check :row="props.row" column="active" />
      </template>

      <template slot="from_to_date" slot-scope="props">
        <span>{{ formatDate(props.row.start_date) + ' - ' + formatDate(props.row.end_date) }}</span>
      </template>

      <template slot="actions" slot-scope="props">
        <column-action
          show-duplicate-button
          :delete-url="`/ti-event/${props.row.id}`"
          :duplicate-url="`/ti-event/${props.row.id}/copy`"
          @deleteItems="refreshTable('appTable')"
          @duplicateItem="goToDuplicatedPage"
          :route="{ path: `/tievents/edit/${props.row.id}`, params: props.row }"
        />
      </template>
    </v-server-table>
  </div>
</template>

<script>
import axios from '@/utils/axios';
import { Event } from 'vue-tables-2';
import i18n from '@/utils/i18n';
import { dateMethods } from '../../mixins/date';

export default {
  middleware: 'auth',
  name: 'TiEvents',
  mixins: [dateMethods],
  data: () => {
    return {
      loading: false,
      totalRecordsCount: null,
      params: {
        page: 1,
        filter: {},
      },
      columns: ['id', 'title', 'description', 'from_to_date', 'active', 'actions'],
      options: {
        skin: [],
        headings: {
          id: '#',
          title: i18n.t('form.event_title'),
          description: i18n.t('form.description'),
          active: i18n.t('form.active'),
          actions: i18n.t('button.edit'),
          from_to_date: i18n.t('form.from_to_date'),
        },
        sortable: [],
        filterByColumn: false,
        columnsDropdown: false,
        customFilters: ['custom'],
        perPage:
          !!localStorage.getItem('perPage') && localStorage.getItem('perPage') !== ''
            ? localStorage.getItem('perPage')
            : 10,
        filterable: false,
        requestFunction: (data) => {
          localStorage.setItem('perPage', data.limit);
          return axios
            .get('/admin/ti-events', {
              params: {
                order: 'active',
                sort: 'desc',
                limit: data.limit,
                filter: data.custom,
                page: data.page,
              },
            })
            .catch((e) => {
              // this.$noty.error(e.error_description);
              this.dispatch('error', e);
            });
        },
        responseAdapter: function (resp) {
          let data = this.getResponseData(resp);
          return {
            data: data.data.items,
            count: data.data.paginator.total_items,
          };
        },
      },
    };
  },
  mounted() {
    Event.$on('vue-tables.tiEventsTable.loaded', ({ data }) => {
      this.totalRecordsCount = data.paginator.total_items;
    });
  },
  destroyed() {
    Event.$off('vue-tables.tiEventsTable.loaded');
  },
  methods: {
    goToDuplicatedPage(resp) {
      this.$router.push(`/tievents/edit/${resp.id}`);
    },
  },
};
</script>
